// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Card_wrapper__ESwwF","card":"Card_card__1eE8R","banner":"Card_banner__3k1su","chip":"Card_chip__3CDro","titleWrapper":"Card_titleWrapper__2Ite8"};